import { configureStore } from '@reduxjs/toolkit';

import modalFallbacksReducer from './modal-fallbacks';

export const store = configureStore({
  reducer: {
    modalFallbacks: modalFallbacksReducer,
  },
});
